<script context="module" lang="ts">
  import { restrictRepAccess } from "@retailer/services/preview_forbidden_flash";

  export function download(id: number) {
    if (restrictRepAccess()) {
      return;
    }
    window.open("/api/retailer/order_groups/" + id + "/download", "_blank");
  }

</script>
